import { PanelTitle } from "~/components/ui/panel/panel-title";
import { ListsBody } from "./body/lists-body";
import { LoadingState, NoListsState } from "./content-state/lists-content-state";
import { useListsData } from "./hooks/use-lists-data";
import { useListsFilter } from "./hooks/use-lists-filter";
import type { StatusGroup } from "../../../task.types";
import { useSharedListSelection } from "../../list-selection-context";

type Props = {
  title?: string;
  sortedItems: StatusGroup[];
  windowId: string;
  onClose: () => void;
};

export const ListsPanel = ({ title, sortedItems, windowId, onClose }: Props) => {
  const { lists, statuses, isLoading, allItems, appliedListIds } = useListsData({
    sortedItems,
    windowId,
  });

  const { setActiveList, clearActiveList } = useSharedListSelection();

  const { handleOpenInNewWindow, handleToggleListFilter } = useListsFilter({
    title,
    windowId,
    lists,
    statuses,
    allItems,
  });

  const onListClick = (listId: number, listName: string) => {
    handleToggleListFilter(listId);

    if (appliedListIds?.[0] === listId) {
      clearActiveList();
    } else {
      setActiveList(listId, listName);
    }
  };

  return (
    <div className="border-gxe-border border-b bg-gray-50 p-4">
      <PanelTitle text="Apply List Filter" onClose={onClose} />

      {isLoading ? (
        <LoadingState />
      ) : !lists || lists.length === 0 ? (
        <NoListsState />
      ) : (
        <ListsBody
          lists={lists}
          activeListId={appliedListIds?.[0]}
          handleListClick={onListClick}
          handleOpenInNewWindow={handleOpenInNewWindow}
        />
      )}
    </div>
  );
};
